import loadable from '@loadable/component';
import { PageLoading } from "@tawn33y/gigsflow-core";

const Privacy = loadable(() => import('@tawn33y/gigsflow-core/dist/pages/Privacy/Privacy'), {
  resolveComponent: (components) => components.Privacy,
  fallback: (
    <PageLoading
      title="Privacy Policy"
      description='This privacy notice for Gigsflow describes how and why we might collect, store, use, and/or share ("process") your information when you use our services'
      url="https://gisflow.com/privacy"
    />
  ),
});

export default function PrivacyPage() {
  return <Privacy />
}
